export const CLIENT_FLAG = {
    PC: '0',
    IOS: '1',
    ANDROID: '2'
};
/**
 * 所有可用的 TeamFace 参数键
 */
export const CLIENT_FLAG_KEYS = Object.keys(CLIENT_FLAG);
/**
 * 所有可用的 TeamFace 参数值
 */
export const CLIENT_FLAG_VALUES = Object.values(CLIENT_FLAG);
/**
 * 验证参数键是否有效
 * @param key - 要验证的参数键
 * @returns 是否为有效的参数键
 */
export function isValidClientFlagKey(key) {
    return CLIENT_FLAG_KEYS.includes(key);
}
/**
 * 获取参数键的中文描述
 * @param key - 参数键
 * @returns 中文描述
 */
export function getClientFlagLabel(key) {
    const labels = {
        PC: 'PC端',
        IOS: 'IOS端',
        ANDROID: 'Android端'
    };
    return labels[key] || '未知';
}
export function getClientFlagLabelByValue(value) {
    const labels = {
        [CLIENT_FLAG.PC]: 'PC端',
        [CLIENT_FLAG.IOS]: 'IOS端',
        [CLIENT_FLAG.ANDROID]: 'Android端'
    };
    return labels[value] || '未知';
}
